import React, {useContext, useState} from "react";
import {useHistory, useLocation} from "react-router-dom";
import MenuForm from "../forms/menuForm";
import {SharedContext, SharedContextActionType} from "../../views/sharedContextProvider";
import Alert from "../modal/alert";

export interface NavBarItem {
    name: string,
    route: string
}

interface IProps {
    data: NavBarItem[],
}

function NavBar(props: IProps) {
    const {data} = props
    const {pathname} = useLocation()
    const history = useHistory()
    const [currentRoute, setCurrentRoute] = useState<string>("")
    const [showUnSavedChangeAlert, setShowUnSavedChangeAlert] = useState<boolean>(false)
    const {sharedContextState, dispatchSharedContext} = useContext(SharedContext)

    const $isActiveRoute = (target: string) => {
        return pathname.indexOf(target) !== -1
    }

    const onOpenHIPPA = () => {
        const HIPPA = "https://viphealth-image.s3.amazonaws.com/HIPAA-Compliance-Guidelines-for-Electronic-Communications.pdf"
        window.open(HIPPA, "_blank")
    }

    const onOpenUserGuide = () => {
        const userGuide = "https://viphealth-image.s3.amazonaws.com/Patient+Engagement+User+Guide.pdf"
        window.open(userGuide, "_blank")
    }

    const $question = (
        <MenuForm classForList={"w-32"} data={[{name: "User Guide", id: 0}, {name: "HIPPA", id: 1}]} onClick={(id) => {
            if (id === 0) {
                onOpenUserGuide()
            } else if (id === 1) {
                onOpenHIPPA()
            }
        }}>
            <div className={"inline-block mt-1 flex-none rounded-full px-2 py-2 font-semibold text-sm leading-tight focus:outline-none focus:ring-0 transition duration-150 ease-in-out text-gray-3 hover:bg-gray-5"}>
                <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M21.6562 11C21.6562 16.8866 16.8849 21.6562 11 21.6562C5.11513 21.6562 0.34375 16.8866 0.34375 11C0.34375 5.11685 5.11513 0.34375 11 0.34375C16.8849 0.34375 21.6562 5.11685 21.6562 11ZM11.286 3.86719C8.94429 3.86719 7.45078 4.85362 6.27799 6.60679C6.12605 6.83392 6.17689 7.14025 6.39465 7.30538L7.88563 8.43588C8.10928 8.60548 8.42793 8.56513 8.6017 8.3447C9.36929 7.37112 9.89562 6.80655 11.0639 6.80655C11.9417 6.80655 13.0275 7.3715 13.0275 8.22271C13.0275 8.86621 12.4963 9.19669 11.6296 9.68262C10.6188 10.2493 9.28125 10.9545 9.28125 12.7188V12.8906C9.28125 13.1754 9.51212 13.4062 9.79688 13.4062H12.2031C12.4879 13.4062 12.7188 13.1754 12.7188 12.8906V12.8333C12.7188 11.6104 16.2931 11.5595 16.2931 8.25C16.2931 5.75773 13.7079 3.86719 11.286 3.86719ZM11 14.5234C9.9101 14.5234 9.02344 15.4101 9.02344 16.5C9.02344 17.5899 9.9101 18.4766 11 18.4766C12.0899 18.4766 12.9766 17.5899 12.9766 16.5C12.9766 15.4101 12.0899 14.5234 11 14.5234Z" fill="#828282"/>
                </svg>
            </div>
        </MenuForm>
    )

    const $rightButtons = (
        <div className={"flex flex-row items-center space-x-2"}>
            {$question}
        </div>
    )

    const $navTab = (
        <div className={"flex flex-row items-center space-x-12 "}>
            {data.map(({ name, route}, idx) => {
                const isSelected = $isActiveRoute(route)
                return (
                    <div key={idx} className={"h-16 flex flex-row items-center justify-center bg-white"}>
                        <button type={"button"} onClick={() => {
                            if (sharedContextState.hasUnSavedChanges) {
                                setCurrentRoute(route)
                                setShowUnSavedChangeAlert(true)
                                return
                            }
                            history.push(route)
                        }} className={"bg-white"}>
                            <p className={`${isSelected ? "text-theme-blue border-theme-blue font-bold" : "text-gray-400 border-transparent font-semibold"} text-base  border-b-2 pb-2`}>{name}</p>
                        </button>
                    </div>
                )
            })}
        </div>
    )

    const $unSavedChangeAlert = (
        <Alert
            isOpen={showUnSavedChangeAlert}
            title={"Unsaved Changes"}
            description={"Are you sure you want to discard this draft? Any changes made in the draft will be lost."}
            rejectAction={{title: "Cancel", onClick: () => {
                setShowUnSavedChangeAlert(false)
            }}
            }
            resolveAction={{title: "Discard", onClick: () => {
                setShowUnSavedChangeAlert(false)
                dispatchSharedContext({type: SharedContextActionType.unsavedChange, state: false})
                history.push(currentRoute)
            }}
            }
        />
    )

    return (
        <div className={"w-full h-16 bg-white shadow-lg px-10 flex flex-row items-center justify-between"}>
            {$navTab}
            {$rightButtons}
            {$unSavedChangeAlert}
        </div>
    )
}

export default NavBar
